import classNames from 'classnames'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  className?: string
  isCollapsed: boolean
  onClick?: VoidFunction
}

const CollapseButton = ({ className, isCollapsed, onClick }: Props): ReactElement => {
  return (
    <div className={classNames('collapse-button-component', className)} onClick={onClick}>
      {isCollapsed ? <MdKeyboardArrowDown color="#fff" size={14} /> : <MdKeyboardArrowUp color="#fff" size={14} />}
    </div>
  )
}

export default CollapseButton
